import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { CUSTOMER_JOURNEYS, LENSES_PACKAGES, LOCALE_CODES, MEDIUM_WIDTH } from '@constants';
import { useBFContext } from '@context';
import { getDefaultInfoTabs, getLensInfoTabs, getVarifocalInfoTabs } from '@utils/constants/info-module';
import { useIsMobile, useTranslation } from '@utils/hooks';

const getTranslatedTexts = translator => {
	return {
		handyLensAddOns: translator('handy-lens-add-ons'),
		enhanceYourPair: translator('enhance-your-pair'),
		prescriptionLensLineup: translator('prescription-lens-lineup'),
		prescriptionLensLowdown: translator('prescription-lens-lowdown'),
	};
};
interface EducationTabsProps {
	isHandyModal: boolean;
}
const useEducationTabs = ({ isHandyModal }: EducationTabsProps) => {
	const { rxType, journey, rxOptions, lensPackage } = useBFContext();
	const { locale } = useRouter();
	const isMobile = useIsMobile({ maxWidth: MEDIUM_WIDTH });
	const isSunLens = journey === CUSTOMER_JOURNEYS.SUNGLASSES;
	const { translator } = useTranslation();
	const translations = getTranslatedTexts(translator);
	const DEFAULT_INFO_TABS = getDefaultInfoTabs(locale);
	const VARIFOCAL_INFO_TABS = getVarifocalInfoTabs(locale);
	const LENS_INFO_TABS = getLensInfoTabs(locale);

	const tabs = useMemo(() => {
		const tabs = LENS_INFO_TABS.filter(tab => !tab.title.includes(LENSES_PACKAGES.PREMIUM));
		if (!rxType || !rxOptions) return tabs;
		const rx = rxType.toLowerCase().split(/-| /)[0];
		const upgrades = rxOptions?.find(option => option.optionValue.toLowerCase().startsWith(rx))?.lenses;

		return tabs.filter(tab => {
			let shouldKeepTab = false;
			const tabTitle = tab.title.toLowerCase().split(/-| /)[0];
			upgrades.forEach(upgrade => {
				const upgradeStr = upgrade.handle.split('-')[0];
				if (tabTitle === 'light' && lensPackage === LENSES_PACKAGES.BASIC) {
					return false;
				}
				if (upgradeStr === tabTitle) {
					shouldKeepTab = true;
				}
			});

			return shouldKeepTab;
		});
	}, [rxType, rxOptions, lensPackage, isSunLens]);

	const educationModalProps = isHandyModal
		? {
				tabs,
				title: translations.handyLensAddOns,
				subTitle: translations.enhanceYourPair,
				forceTabs: !isMobile,
			}
		: {
				tabs: locale === LOCALE_CODES.GB ? VARIFOCAL_INFO_TABS : DEFAULT_INFO_TABS,
				title: translations.prescriptionLensLineup,
				subTitle: translations.prescriptionLensLowdown,
			};
	return {
		educationModalProps,
	};
};
export default useEducationTabs;
